"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Link = _interopRequireDefault(require("@mui/material/Link"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _String = _interopRequireDefault(require("./String.js"));
var _Navigator = _interopRequireDefault(require("../App/Navigator.js"));
var _LinkModule = _interopRequireDefault(require("./Link.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Link component abstracting Material UI's `Link`
 * 
 * Original author @heron-web/material (no longer maintained)
 */class Link extends _react.default.PureComponent {
  /**
   * Clicked.
   *
   * @param {Event} e
   * @return {void}
   */
  handleClick = e => {
    e.stopPropagation();
    const uri = this.props.uri;
    const disabled = this.props.disabled;
    if (disabled || !uri?.startsWith("mailto:")) {
      e.preventDefault();
      if (!disabled) {
        if (uri) _Navigator.default.navigate(uri);else this.props.onClick?.(this.props.value, e);
      }
    }
  };

  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      className: `${_LinkModule.default.root} ${this.props.disabled ? _LinkModule.default.disabled : ""} ${this.props.className || ""}`.trim(),
      color: this.props.color,
      href: !this.props.disabled ? this.props.uri : undefined,
      onClick: this.handleClick,
      onKeyPress: this.handleKeyPress,
      style: this.props.style,
      tabIndex: !this.props.disabled ? "0" : "-1",
      underline: "hover",
      ...this.props.LinkProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        bold: this.props.bold,
        color: "inherit",
        classNameTypography: _LinkModule.default.string,
        noFlex: true,
        str: this.label,
        ...this.props.StringProps
      })
    });
  }

  /**
   * Get the label.
   * 
   * @return {String}
   */
  get label() {
    const lbl = this.props.label;
    if (this.props.endArrow) return `${lbl}${String.fromCharCode(160)}${String.fromCharCode(8594)}`;else if (this.props.startArrow) return `${String.fromCharCode(8592)}${String.fromCharCode(160)}${lbl}`;else return lbl;
  }
  static propTypes = {
    LinkProps: _propTypes.default.object,
    StringProps: _propTypes.default.object,
    bold: _propTypes.default.bool,
    className: _propTypes.default.string,
    color: _propTypes.default.oneOf(["primary", "secondary", "textPrimary", "textSecondary", "error", "initial", "inherit"]),
    disabled: _propTypes.default.bool,
    endArrow: _propTypes.default.bool,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    startArrow: _propTypes.default.bool,
    style: _propTypes.default.object,
    uri: _propTypes.default.string,
    value: _propTypes.default.any
  };
  static defaultProps = {
    bold: false,
    color: "primary",
    disabled: false,
    endArrow: false,
    startArrow: false
  };
}
var _default = exports.default = Link;